import { useTranslation } from "react-i18next";
import { BadgeCheck } from "lucide-react";
import { cn } from "@/utils/cn";

/** Next to the official MaiHRMS account's name, like a verified account. */
export const VerifiedBadge = ({ className }: { className?: string }) => {
  const { t } = useTranslation("chat");
  return (
    <BadgeCheck
      className={cn("size-4 shrink-0 fill-info text-info-foreground", className)}
      aria-label={t("channel.verified")}
      role="img"
    />
  );
};
